import DayPickerContainer from './DayPickerContainer';
export default DayPickerContainer;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/components/DateRangePicker/components/DayPickerContainer/index.js